import React from 'react'
import Reflux from 'reflux'
import { Card, CardHeader, CardBody, Table } from 'reactstrap'

import CurrentRecipeStore from '~/stores/currentRecipe.js'


export default class RecipeIngredientsView extends Reflux.Component {
	constructor(props) {
		super(props)

		this.store = CurrentRecipeStore
		this.storeKeys = [
			'recipeIngredients'
		]
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	render() {
		const hasIngredients = (this.state.recipeIngredients.length > 0)
		const theIngredients = this.state.recipeIngredients.map((theIngredient) => {
			let theAmount = theIngredient.amount.toString()

			// replace the integers with friendly strings
			theAmount = theAmount.replace('0.125', ' 1/8')
			theAmount = theAmount.replace('0.25', ' 1/4')
			theAmount = theAmount.replace('0.33', ' 1/3')
			theAmount = theAmount.replace('0.5', ' 1/2')
			theAmount = theAmount.replace('0.66', ' 2/3')
			theAmount = theAmount.replace('0.75', ' 3/4')
			// fractions without wholes
			theAmount = theAmount.replace('0 ', '')

			return (
				<tr
					key={theIngredient.recipeIngredientID}
				>
					<td style={{ width: '1%', whiteSpace: 'nowrap' }}>
						{theAmount}
						{
							theIngredient.quantityName !== '' &&

							<React.Fragment>
								{' '}
								{theIngredient.quantityName}
							</React.Fragment>
						}
					</td>
					<td style={{ width: '99%' }}>
						{theIngredient.ingredientName}
						{
							theIngredient.ingredientTypeName !== '' &&

							<React.Fragment>
								{', '}
								{theIngredient.ingredientTypeName}
							</React.Fragment>
						}
					</td>
				</tr>
			)
		})

		return (
			<Card>
				<CardHeader>
					Ingredients
				</CardHeader>

				<CardBody>
					{
						hasIngredients === false &&
						<em>{'No ingredients have been entered for this recipe'}</em>
					}
					{
						hasIngredients === true &&
						<Table size="sm" style={{ padding: 0, margin: 0 }}>
							<tbody>
								{theIngredients}
							</tbody>
						</Table>
					}
				</CardBody>
			</Card>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/recipeIngredients/view.jsx